import React, {
  useEffect,
  useRef,
  useState
} from 'react';

import {
  useNavigate
} from 'react-router-dom';

import './Otp-Varification.css';


export default function OtpVerification() {

  const navigate = useNavigate();


  // =====================================================
  // OTP STATE
  // =====================================================

  const [otp, setOtp] = useState([
    '',
    '',
    '',
    '',
    '',
    ''
  ]);


  const [timer, setTimer] = useState(58);

  const [canResend, setCanResend] =
    useState(false);

  const [loading, setLoading] =
    useState(false);


  const inputRefs =
    useRef([]);


  // =====================================================
  // GET GENERATED OTP
  // =====================================================

  const getGeneratedOtp = () => {

    const savedOtp =
      localStorage.getItem(
        'generated_otp'
      );


    if (
      savedOtp &&
      /^\d{6}$/.test(savedOtp)
    ) {

      return savedOtp;
    }


    return '';
  };


  // =====================================================
  // AUTO FILL GENERATED OTP
  // =====================================================

  useEffect(() => {

    const savedOtp =
      getGeneratedOtp();


    if (!savedOtp) {
      return;
    }


    const otpArray =
      savedOtp.split('');


    setOtp(otpArray);


    // Focus last OTP box
    setTimeout(() => {

      inputRefs.current[5]?.focus();

    }, 100);

  }, []);


  // =====================================================
  // TIMER
  // =====================================================

  useEffect(() => {

    if (timer <= 0) {

      setCanResend(true);

      return;
    }


    const interval =
      setInterval(() => {

        setTimer(
          (prev) => prev - 1
        );

      }, 1000);


    return () =>
      clearInterval(interval);

  }, [timer]);


  // =====================================================
  // OTP INPUT
  // =====================================================

  const handleChange = (
    index,
    value
  ) => {

    if (!/^\d*$/.test(value)) {
      return;
    }


    const newOtp =
      [...otp];


    newOtp[index] =
      value.slice(-1);


    setOtp(newOtp);


    if (
      value &&
      index < 5
    ) {

      inputRefs.current[
        index + 1
      ]?.focus();

    }

  };


  // =====================================================
  // BACKSPACE
  // =====================================================

  const handleKeyDown = (
    index,
    e
  ) => {

    if (
      e.key === 'Backspace' &&
      !otp[index] &&
      index > 0
    ) {

      inputRefs.current[
        index - 1
      ]?.focus();

    }

  };


  // =====================================================
  // PASTE OTP
  // =====================================================

  const handlePaste = (e) => {

    e.preventDefault();


    const pastedData =
      e.clipboardData
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 6);


    if (!pastedData) {
      return;
    }


    const newOtp = [
      '',
      '',
      '',
      '',
      '',
      ''
    ];


    pastedData
      .split('')
      .forEach(
        (char, index) => {

          newOtp[index] =
            char;

        }
      );


    setOtp(newOtp);


    const nextIndex =
      Math.min(
        pastedData.length,
        5
      );


    inputRefs.current[
      nextIndex
    ]?.focus();

  };


  // =====================================================
  // GENERATE NEW OTP
  // =====================================================

  const generateNewOtp = () => {

    return String(
      Math.floor(
        100000 +
        Math.random() * 900000
      )
    );

  };


  // =====================================================
  // RESEND OTP
  // =====================================================

  const handleResend = () => {

    if (
      !canResend ||
      loading
    ) {

      return;
    }


    // =================================================
    // GENERATE NEW 6-DIGIT OTP
    // =================================================

    const newOtp =
      generateNewOtp();


    // =================================================
    // SAVE NEW OTP
    // =================================================

    localStorage.setItem(
      'generated_otp',
      newOtp
    );


    // =================================================
    // SAVE GENERATION TIME
    // =================================================

    localStorage.setItem(
      'otp_generated_at',
      String(Date.now())
    );


    // =================================================
    // AUTO FILL OTP
    // =================================================

    setOtp(
      newOtp.split('')
    );


    // =================================================
    // RESET TIMER
    // =================================================

    setTimer(58);

    setCanResend(false);


    console.log(
      'New Generated OTP:',
      newOtp
    );


    // Focus first box
    setTimeout(() => {

      inputRefs.current[0]?.focus();

    }, 100);

  };


  // =====================================================
  // VERIFY / SAVE OTP
  // =====================================================

  const handleSubmit = async (e) => {

    e.preventDefault();


    const enteredOtp =
      otp.join('');


    // =================================================
    // OTP LENGTH VALIDATION
    // =================================================

    if (
      enteredOtp.length !== 6
    ) {

      alert(
        'Please enter complete 6-digit OTP code.'
      );

      return;
    }


    // =================================================
    // GET GENERATED OTP
    // =================================================

    const generatedOtp =
      localStorage.getItem(
        'generated_otp'
      );


    // =================================================
    // GENERATED OTP NOT FOUND
    // =================================================

    if (
      !generatedOtp ||
      !/^\d{6}$/.test(
        generatedOtp
      )
    ) {

      alert(
        'OTP expired or not found. Please resend OTP.'
      );

      return;
    }


    // =================================================
    // COMPARE OTP
    // =================================================

    if (
      enteredOtp !== generatedOtp
    ) {

      alert(
        'Invalid OTP. Please enter the correct 6-digit OTP.'
      );

      return;
    }


    // Prevent double click
    if (loading) {
      return;
    }


    setLoading(true);


    try {

      // =================================================
      // GET USER ID
      // =================================================

      const userId =
        localStorage.getItem(
          'user_id'
        );


      // =================================================
      // GET DEVICE UUID
      // =================================================

      const deviceUUID =
        localStorage.getItem(
          'device_uuid'
        );


      // =================================================
      // USER NOT FOUND
      // =================================================

      if (
        !userId &&
        !deviceUUID
      ) {

        alert(
          'User information not found. Please restart onboarding.'
        );

        return;
      }


      console.log(
        'User ID:',
        userId
      );


      console.log(
        'Device UUID:',
        deviceUUID
      );


      console.log(
        'Generated OTP:',
        generatedOtp
      );


      console.log(
        'Entered OTP:',
        enteredOtp
      );


      // =================================================
      // API REQUEST
      // =================================================

      const response =
        await fetch(
          'https://coinyoco.world/brobizee-api/update_user.php',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body: JSON.stringify({

              user_id:
                userId,

              device_uuid:
                deviceUUID,

              otp_num:
                enteredOtp

            })
          }
        );


      // =================================================
      // HTTP ERROR
      // =================================================

      if (!response.ok) {

        throw new Error(
          `HTTP Error: ${response.status}`
        );

      }


      // =================================================
      // JSON RESPONSE
      // =================================================

      const result =
        await response.json();


      console.log(
        'OTP API Response:',
        result
      );


      // =================================================
      // SUCCESS
      // =================================================

      if (result.success) {


        // =================================================
        // SAVE VERIFIED OTP
        // =================================================

        localStorage.setItem(
          'otp_num',
          enteredOtp
        );


        // =================================================
        // OTP VERIFIED FLAG
        // =================================================

        localStorage.setItem(
          'otp_verified',
          'true'
        );


        // =================================================
        // KEEP USER ID
        // =================================================

        if (result.user_id) {

          localStorage.setItem(
            'user_id',
            String(
              result.user_id
            )
          );

        }


        // =================================================
        // NEXT PAGE
        // =================================================

        navigate(
          '/username'
        );


      } else {

        alert(
          result.message ||
          'OTP save failed.'
        );

      }


    } catch (error) {

      console.error(
        'OTP API Error:',
        error
      );


      alert(
        'Server se connection nahi ho raha.'
      );


    } finally {

      setLoading(false);

    }

  };


  // =====================================================
  // OTP COMPLETE
  // =====================================================

  const isComplete =
    otp.every(
      (digit) =>
        digit !== ''
    );


  // =====================================================
  // UI
  // =====================================================

  return (

    <div className="otp-page-wrapper">

      <div className="otp-app-card">

        {/* Ambient Background */}

        <div className="otp-ambient otp-ambient-one"></div>

        <div className="otp-ambient otp-ambient-two"></div>


        {/* Header */}

        <header className="otp-header">

          <button
            type="button"
            className="otp-back-btn"
            aria-label="Go Back"
            onClick={() =>
              navigate(-1)
            }
            disabled={loading}
          >

            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >

              <path d="M15 18l-6-6 6-6" />

            </svg>

          </button>


          <div className="otp-step-indicator">

            <span className="otp-step"></span>

            <span className="otp-step active"></span>

            <span className="otp-step"></span>

            <span className="username-progress-dot"></span>

          </div>

        </header>


        {/* Main */}

        <main className="otp-content">


          {/* Icon */}

          <div className="otp-icon-wrapper">

            <div className="otp-icon">

              <svg
                width="31"
                height="31"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              >

                <rect
                  x="4"
                  y="5"
                  width="16"
                  height="14"
                  rx="2.5"
                />

                <path d="M8 10h.01" />

                <path d="M12 10h.01" />

                <path d="M16 10h.01" />

                <path d="M8 14h8" />

              </svg>

            </div>

          </div>


          {/* Title */}

          <div className="otp-title-group">

            <span className="otp-eyebrow">
              SECURITY CHECK
            </span>

            <h1 className="otp-title">

              Verify your

              <span>
                {' '}number
              </span>

            </h1>

            <p className="otp-subtitle">

              We sent a 6-digit verification code
              to

              <strong>
                {' '}

                {localStorage.getItem(
                  'mobile_number'
                ) ||
                  '+91 xxx xxx xxx x'}

              </strong>

            </p>

          </div>


          {/* OTP FORM */}

          <form
            onSubmit={handleSubmit}
            className="otp-form"
          >


            {/* OTP Inputs */}

            <div className="otp-input-container">

              {otp.map(
                (
                  digit,
                  idx
                ) => (

                  <input

                    key={idx}

                    ref={(el) =>
                      (
                        inputRefs.current[
                          idx
                        ] = el
                      )
                    }

                    type="text"

                    inputMode="numeric"

                    autoComplete={
                      idx === 0
                        ? 'one-time-code'
                        : 'off'
                    }

                    maxLength={1}

                    value={digit}

                    onChange={(e) =>
                      handleChange(
                        idx,
                        e.target.value
                      )
                    }

                    onKeyDown={(e) =>
                      handleKeyDown(
                        idx,
                        e
                      )
                    }

                    onPaste={
                      handlePaste
                    }

                    className={`otp-box ${
                      digit
                        ? 'filled'
                        : ''
                    }`}

                    aria-label={
                      `Digit ${
                        idx + 1
                      }`
                    }

                    disabled={loading}

                  />

                )
              )}

            </div>


            {/* OTP STATUS */}

            <div className="otp-status">

              <span className="otp-lock">

                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >

                  <rect
                    x="5"
                    y="11"
                    width="14"
                    height="10"
                    rx="2"
                  />

                  <path d="M8 11V7a4 4 0 018 0v4" />

                </svg>

              </span>

              <span>
                Your verification code is private
              </span>

            </div>


            {/* RESEND */}

            <div className="resend-row">

              <span className="resend-text">
                Didn't receive the OTP?
              </span>


              {canResend ? (

                <button
                  type="button"
                  onClick={
                    handleResend
                  }
                  className="resend-btn clickable"
                  disabled={loading}
                >
                  Resend OTP
                </button>

              ) : (

                <span className="resend-btn">

                  Resend in{' '}

                  <strong>
                    {timer < 10
                      ? `0${timer}`
                      : timer}
                  </strong>

                  {' '}sec

                </span>

              )}

            </div>


            {/* VERIFY */}

            <button
              type="submit"
              className={`verify-btn ${
                isComplete
                  ? 'enabled'
                  : ''
              }`}
              disabled={
                !isComplete ||
                loading
              }
            >

              <span>

                {loading
                  ? 'Verifying...'
                  : 'Verify OTP'}

              </span>


              <span className="verify-arrow">

                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >

                  <path d="M5 12h14" />

                  <path d="M13 6l6 6-6 6" />

                </svg>

              </span>

            </button>

          </form>

        </main>


        {/* Footer */}

        <footer className="otp-footer">

          <img
            src="/images/logo.png"
            alt="BroBizee Logo"
            className="brand-logo-img"
          />

          <span>
            Secure. Simple. BroBizee.
          </span>

        </footer>

      </div>

    </div>
  );
}